<template v-once>
  <section class="conclusion-section d-none d-md-block">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <h5 class="text-uppercase text-white">
            International Consortium of Investigative Journalists
          </h5>
          <p>
            910 17th Street NW Suite 410<br />
            Washington DC 20006 USA
          </p>
          <p>
            <strong>
              <a href="mailto:contact@icij.org" class="text-warning">contact@icij.org</a>
            </strong>
          </p>
        </div>
        <div class="col-md-6 offset-md-2">
          <div class="row">
            <div class="col-md-6">
              <h5>
                <a href="https://www.icij.org/investigations/paradise-papers/" class="text-warning text-uppercase">
                  Paradise Papers
                </a>
              </h5>
              <ul class="list-unstyled">
                <li class="list-unstyled-item">
                  <a href="" target="_blank">
                    The Influencers
                  </a>
                </li>
                <li class="list-unstyled-item">
                  <a href="" target="_blank">
                    Offshore Leaks Database
                  </a>
                </li>
                <li class="list-unstyled-item">
                  <a href="" target="_blank">
                    The Mauritius
                  </a>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <h5 class="text-warning text-uppercase">
                Follow us
              </h5>
              <ul class="list-unstyled">
                <li class="list-unstyled-item">
                  <a href="https://www.facebook.com/ICIJ.org" target="_blank">
                    Facebook
                  </a>
                </li>
                <li class="list-unstyled-item">
                  <a href="https://www.linkedin.com/company/1732242/" target="_blank">
                    LinkedIn
                  </a>
                </li>
                <li class="list-unstyled-item">
                  <a href="https://twitter.com/icijorg" target="_blank">
                    Twitter
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <p class="text-white text-md-right small">
        <strong>© {{ year }} — The International Consortium of Investigative Journalists.</strong> All rights reserved.
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ConclusionSection',
  computed: {
    year () {
      return (new Date()).getFullYear()
    }
  }
}
</script>

<style lang="scss">
  .conclusion-section {
    background: black;
    color: #999;
    padding:$spacer * 4 0;

    @include media-breakpoint-down(md) {
      padding: $spacer;
    }

    a {
      color: inherit;
    }
  }
</style>



// WEBPACK FOOTER //
// ConclusionSection.vue?3194524c